module.exports = __webpack_public_path__ + "img/arrow-left.31a3b046.svg";